import { render, staticRenderFns } from "./BlocSmsList.vue?vue&type=template&id=44574fc9"
import script from "./BlocSmsList.vue?vue&type=script&lang=ts"
export * from "./BlocSmsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports